import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import authReducer from "./reducers/auth";
import sessionReducer from "./reducers/session";
import commandsReducer from "./reducers/commands";
import panelsReducer from "./reducers/panels";
import modalsReducer from "./reducers/modals";

import authSaga from "./sagas/authSaga";
import sessionSaga from "./sagas/sessionSaga";

export const rootReducer = combineReducers({
    auth: authReducer,
    session: sessionReducer,
    commands: commandsReducer,
    panels: panelsReducer,
    modals: modalsReducer,
});

export function* rootSaga() {
    yield all([
        authSaga(),
        sessionSaga()
    ]);
}
